import * as React from 'react';
import { SVGProps } from 'react';

const SvgMomAndBaby = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M10.57 8.92v2.4a5.224 5.224 0 0 0 5.22 5.22 5.224 5.224 0 0 0 5.22-5.22v-2.4"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M10.57 11.21v-2.4c.04-1.36.61-2.64 1.59-3.59.97-.95 2.28-1.47 3.64-1.47 1.36 0 2.66.53 3.64 1.47a5.29 5.29 0 0 1 1.59 3.59v2.4M6.75 33.12v-8.5c0-1.61.47-3.18 1.37-4.52a8.03 8.03 0 0 1 3.65-2.99c1.48-.62 3.09-.46 4.69-.46.75 0 1.55.08 2.35.28 1.5.37 2.78 1.33 3.71 2.56l.66.87m1.57 12.17v-2.08"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M21.44 9.43c-2.33.24-4.66-.37-6.58-1.7-.12.4-.3.78-.55 1.13-.52.72-1.56 1.59-3.57 1.59"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M10.95 6.23c-.81-.38-1.72-.5-2.6-.35-1.05.33-1.97.98-2.62 1.87-.65.89-.99 1.96-.98 3.07v6.82l1.94-1.37c.38-.27 2.96-1.78 4.06-3.92"
    />
    <path
      fill="currentColor"
      d="m31.74 18.83-1.53-1.54.3-.28c.41-.41.97-.64 1.56-.64.59 0 1.14.23 1.56.64l-1.54 1.54h-.03l-.3.28h-.02Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m25.94 20.37-.44-.45c-.3-.3-.71-.47-1.14-.47-.43 0-.84.17-1.14.47L20 23.15a4.277 4.277 0 0 0 0 6.04c.4.4.87.72 1.39.93.52.22 1.08.32 1.64.32.56 0 1.12-.11 1.64-.33.52-.22.99-.53 1.39-.94l3.22-3.23c.3-.3.47-.71.47-1.14 0-.43-.17-.84-.47-1.14l-.46-.44"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M28.95 23.1a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Zm-9.2.1h10"
    />
    <path
      fill={props.fill}
      d="M5.98 32.41v4.91l15.82.02 4.71-4.9-20.53-.04v.01Z"
    />
  </svg>
);

export default SvgMomAndBaby;
